import { z } from 'zod';

import { preprocessEmptyStringAsNull } from '@dealstack/shared/lib/common/common.ts';
import { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n.ts';
import { PeriodUnitType } from '@dealstack/shared/lib/generated';
import { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';

export enum RedemptionRightsType {
	FIXED = 'fixed',
	PERPETUAL = 'perpetual',
}

export const SecurityRedemptionRightsShape = (
	tCapManage: TranslateFunction<I18Namespaces.CAP_MANAGE>
) =>
	z
		.object({
			term: z.nativeEnum(PeriodUnitType).optional().nullable(),
			termDuration: z.preprocess(
				preprocessEmptyStringAsNull,
				z.union([z.string(), z.number().int().positive()]).nullable().optional()
			),
			type: z.nativeEnum(RedemptionRightsType),
		})
		.superRefine((data, ctx) => {
			if (data.type === RedemptionRightsType.FIXED) {
				if (data.term === null || data.term === undefined) {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: tCapManage('securities.redemptionRights.validation.termRequired'),
						path: ['term'],
					});
				}

				if (typeof data.termDuration !== 'number') {
					ctx.addIssue({
						code: z.ZodIssueCode.custom,
						message: tCapManage(
							'securities.redemptionRights.validation.termDurationRequired'
						),
						path: ['termDuration'],
					});
				}
			}
		});

export type SecurityRedemptionRightsFormDto = z.infer<
	ReturnType<typeof SecurityRedemptionRightsShape>
>;
